<template>
    <div class="template-connected">
      <div id="container" class="no-padding">
        <div class="notfound">
          <div class="page-content">
            <div class="page-single-content">
              <h1>Accès refusé</h1>
              <b-img
                src="../img/403.png"
                class="img-login"
                alt="Accès refusé"
              ></b-img>
              <h3>Vous ne disposez pas des droits requis pour visionner cette demande</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "Forbidden",
  };
  </script>
  
  <style></style>